import React from "react";
import CountrySection from "./CountrySection";
import StateSection from "./StateSection";
import CitySection from "./CitySection";
import StreamSection from "./StreamSection";
import CourseSection from "./CourseSection";
import SpecializationSection from "./Specializations";

const SelectedFilterPopup = ({
  filterData,
  selectedFilterCategory,
  setSelectedFilterCategory,
  filterOptions,
  collegesUrl,
  location,
  filterSecStreamData,
  availableStreams,
  filterSpecialization,
  handleModalToggle,
}: any) => {

  return (
    <div>
      {filterOptions?.country?.country_url !== "study-in-india" &&
      selectedFilterCategory === "country" || ""|| null ? (
        <CountrySection
          filterData={filterData}
          setSelectedFilterCategory={setSelectedFilterCategory}
          filterOptions={filterOptions}
          handleModalToggle={handleModalToggle}
        />
      ) : null}

      {selectedFilterCategory === "state" || ""|| null ? (
        <StateSection
          filterData={filterData}
          setSelectedFilterCategory={setSelectedFilterCategory}
          filterOptions={filterOptions}
          collegesUrl={collegesUrl}
          location={location}
          handleModalToggle={handleModalToggle}
        />
      ) : null}

      {selectedFilterCategory === "city" ? (
        <CitySection
          setSelectedFilterCategory={setSelectedFilterCategory}
          filterOptions={filterOptions}
          location={location}
          filterData={filterData}
          collegesUrl={collegesUrl}
          handleModalToggle={handleModalToggle}
        />
      ) : null}

      {selectedFilterCategory === "stream" &&
      Array.isArray(availableStreams) &&
      availableStreams?.length > 0 ? (
        <StreamSection
          setSelectedFilterCategory={setSelectedFilterCategory}
          availableStreams={availableStreams}
          filterOptions={filterOptions}
          filterSecStreamData={filterSecStreamData}
          handleModalToggle={handleModalToggle}
        />
      ) : null}

      {selectedFilterCategory === "course" ? (
        <CourseSection
          filterData={filterData}
          filterOptions={filterOptions}
          filterSecStreamData={filterSecStreamData}
          setSelectedFilterCategory={setSelectedFilterCategory}
          handleModalToggle={handleModalToggle}
        />
      ) : null}
      {selectedFilterCategory === "specialization" ? (
            <SpecializationSection
              filterData={filterData}
              setSelectedFilterCategory={setSelectedFilterCategory}
              filterSecStreamData={filterSecStreamData}
              filterOptions={filterOptions}
              filterSpecialization={filterSpecialization}
            />
          ) : null} 

    </div>
  );
};

export default SelectedFilterPopup;
